import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { artistsAPI } from '../services/api';
import '../styles/landing.css';

function ArtistsList() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArtists();
  }, []);

  const loadArtists = async () => {
    try {
      const response = await artistsAPI.getAll();
      const data = response?.data || [];
      setArtists(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading artists:', error);
      setArtists([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh' }}>
          <h1 className="section-title" style={{ marginBottom: '40px' }}>ALL ARTISTS</h1>
          <p style={{ color: '#a0a0a0', textAlign: 'center' }}>Loading artists...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="container" style={{ paddingTop: '100px', paddingBottom: '80px' }}>
        <h1 className="section-title" style={{ marginBottom: '40px' }}>ALL ARTISTS</h1>
        <div className="artists-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '30px' }}>
          {!Array.isArray(artists) || artists.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#a0a0a0' }}>
              <p>No artists available yet.</p>
              <Link to="/" style={{ color: '#228b22', textDecoration: 'none', marginTop: '20px', display: 'inline-block' }}>
                ← Back to Home
              </Link>
            </div>
          ) : (
            artists.map((artist) => (
              <Link 
                key={artist.id} 
                to={`/artists/${artist.id}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block', height: '100%' }}
              >
                <div className="artist-card" style={{ cursor: 'pointer' }}>
                  <div 
                    className="artist-image-placeholder"
                    style={artist.image ? {
                      backgroundImage: `url(${artist.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      minHeight: '250px'
                    } : { minHeight: '250px' }}
                  ></div>
                  <h3 className="artist-name">{artist.name}</h3>
                  <span style={{ 
                    color: '#228b22', 
                    fontSize: '0.9rem',
                    display: 'block',
                    marginTop: '10px'
                  }}>view details →</span>
                </div>
              </Link>
            ))
          )}
        </div>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ArtistsList;

